import axios from 'axios';

// 错题本：列表需要跨页共享（侧栏计数等），走 vuex namespaced module
export default {
  namespaced: true,
  state: () => ({ list: [], demo: false }),
  mutations: {
    set(state, { list, demo }) { state.list = list || []; state.demo = !!demo; },
  },
  actions: {
    async load({ commit }) {
      const { data } = await axios.get('/api/mistakes');
      if (Array.isArray(data)) commit('set', { list: data });
      else commit('set', data);
    },
    // 返回 { record } 或 { demo, record }，页面据此提示
    async create(_, payload) {
      const { data } = await axios.post('/api/mistakes', payload);
      return data;
    },
    async remove({ state, commit }, mistake) {
      await axios.delete(`/api/mistakes/${mistake.id}`);
      commit('set', { list: state.list.filter((m) => m.id !== mistake.id), demo: state.demo });
    },
  },
};
